document.addEventListener("DOMContentLoaded", function () {
    var targetPageID = "shopify-section-template--20107142529306__main";
    var currentPageID = document.querySelector(".page-section").getAttribute("id");

    // Check if the current page has the desired ID
    if (currentPageID === targetPageID) {
      var rteElement = document.querySelector(".rte");
      var maxLength = 350; // Change this value to the desired character limit
      var originalContent = rteElement.innerHTML;
      var readMoreLink = document.createElement("a");
      var readLessLink = document.createElement("a");

      // Function to truncate the content
      function truncateContent() {
        var truncatedContent = originalContent.slice(0, maxLength) + "...";
        rteElement.innerHTML = truncatedContent;
        rteElement.appendChild(readMoreLink);
      }

      // Function to expand the content
      function expandContent() {
        rteElement.innerHTML = originalContent;
        rteElement.appendChild(readLessLink);
      }

      // Create the "Read more" link
      readMoreLink.setAttribute("href", "#");
      readMoreLink.textContent = "Read more";
      readMoreLink.style.display = "block";
      readMoreLink.addEventListener("click", function (event) {
        event.preventDefault();
        expandContent();
      });

      // Create the "Read less" link
      readLessLink.setAttribute("href", "#");
      readLessLink.textContent = "Read less";
      readLessLink.style.display = "block";
      readLessLink.addEventListener("click", function (event) {
        event.preventDefault();
        truncateContent();
      });

      // Initialize the content
      if (originalContent.length > maxLength) {
        truncateContent();
      }
    }
  });